var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversationIconStatusSeen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46662 12.3241L0.930786 8.78822L1.64362 8.08572L4.47695 10.9191L4.70762 10.6882L5.41029 11.3907L4.46662 12.3241ZM8.23329 12.3241L4.69745 8.78822L5.39995 8.07539L8.23329 10.9087L14.3666 4.77539L15.0691 5.48822L8.23329 12.3241ZM8.00245 8.78822L7.28962 8.08572L10.5896 4.78572L11.3025 5.48822L8.00245 8.78822Z",
    fill: "#38B000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationIconStatusSeen);
export default __webpack_public_path__ + "static/media/conversation_icon_status_seen.a9f83e4abaef5d4c49b8602092916f2b.svg";
export { ForwardRef as ReactComponent };